import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import Order from "./pages/Order";
import Purchase from "./pages/Purchase";
import Billing from "./pages/Billing";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/order" element={<Order />} />
          <Route path="/purchase" element={<Purchase />} />
          <Route path="/billing" element={<Billing />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
